import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import { FiFacebook, FiPhone } from "react-icons/fi";
import { FaInstagram } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";

import "./Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScroll = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      {/* Top Bar */}
      <div className="header-top">
        <div className="container">
          <ul className="header-top-list">
            <li>
              <a href="#" className="header-top-link">
                <FaXTwitter />
              </a>
            </li>
            <li>
              <a href="#" className="header-top-link">
                <FiFacebook />
              </a>
            </li>
            <li>
              <a href="#" className="header-top-link">
                <FaInstagram />
              </a>
            </li>
            <li>
              <a
                href="mailto:info@syrianrealestate.net"
                className="header-top-link"
              >
                <MdOutlineEmail /> info@syrianrealestate.net
              </a>
            </li>
            <li>
              <a href="tel:+963985148289" className="header-top-link">
                <FiPhone /> +963 985 148 289 | +966 535 706 325
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo">
            <img
              src="/assets/img/logo.png"
              alt="سوريا للعقارات"
              className="logo-image"
            />
            <span>سوريا للعقارات</span>
          </Link>

          <ul className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
            <li>
              <Link
                to="/"
                onClick={() => {
                  setIsMenuOpen(false);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                الرئيسية
              </Link>
            </li>
            <li>
              <Link to="/properties" onClick={() => setIsMenuOpen(false)}>
                العقارات
              </Link>
            </li>
            <li>
              <a href="#about" onClick={(e) => handleScroll(e, "about")}>
                من نحن
              </a>
            </li>
            <li>
              <a href="#statistics" onClick={(e) => handleScroll(e, "statistics")}>
                الاحصائيات
              </a>
            </li>
            <li>
              <a href="#contact" onClick={(e) => handleScroll(e, "contact")}>
                اتصل بنا
              </a>
            </li>
          </ul>

          <button
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
